import { render, staticRenderFns } from "./CookieNotification.vue?vue&type=template&id=b51d7e8e&scoped=true&"
import script from "./CookieNotification.vue?vue&type=script&lang=js&"
export * from "./CookieNotification.vue?vue&type=script&lang=js&"
import style0 from "./CookieNotification.vue?vue&type=style&index=0&id=b51d7e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51d7e8e",
  null
  
)

export default component.exports